import React, { useState, useRef } from 'react';
import { IconButton } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

export interface DateTimePickerIconProps {
  value: dayjs.Dayjs;
  onChange: (newValue: dayjs.Dayjs | null) => void;
  useUTCTime: boolean;
  minDateTime: dayjs.Dayjs;
  maxDateTime: dayjs.Dayjs;
}

const DateTimePickerIcon: React.FC<DateTimePickerIconProps> = ({
  value,
  onChange,
  useUTCTime,
  minDateTime,
  maxDateTime
}) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleDateTimePickerAccept = (newValue: dayjs.Dayjs | null) => {
    onChange(newValue);
    setDatePickerOpen(false);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        size="small"
        onClick={() => setDatePickerOpen(true)}
        sx={{
          color: 'text.secondary',
          '&:hover': {
            color: 'primary.main'
          }
        }}
        aria-label="Open date and time picker"
      >
        <CalendarMonthIcon fontSize="small" />
      </IconButton>
      <DateTimePicker
        key={`picker-${useUTCTime}`}
        value={value}
        onAccept={handleDateTimePickerAccept}
        onClose={() => setDatePickerOpen(false)}
        open={datePickerOpen}
        minDateTime={minDateTime}
        maxDateTime={maxDateTime}
        format="YYYY-MM-DD HH:mm"
        ampm={false}
        slotProps={{
          textField: {
            sx: { display: 'none' }
          },
          popper: {
            anchorEl: anchorRef.current,
            placement: 'bottom-start'
          }
        }}
      />
    </>
  );
};

export default DateTimePickerIcon;